import { SequentialFetchQueue } from './sequential-fetch-queue';
import { fetch, Request } from 'cross-fetch';
const fetchTimeout = 20000;
const queueTimeout = 120000;
export const timeoutErrorString = 'Request timed out';
export function internalFetch(url, options, callback) {
    const request = new Request(url, options);
    return fetchQueue.add(request, callback);
}
const fetchQueue = new SequentialFetchQueue(fetch, fetchTimeout, queueTimeout);
export function asyncFetchWithTimeout(url, timeout, requestOptions) {
    return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
            reject(new Error(timeoutErrorString));
        }, timeout);
        fetch(url, requestOptions ? requestOptions : {})
            .then((response) => {
            clearTimeout(timeoutId);
            resolve(response);
        })
            .catch((error) => {
            clearTimeout(timeoutId);
            reject(error);
        });
    });
}
//# sourceMappingURL=fetch.js.map